<template>
  <VaSidebarItem
    v-if="isExternal"
    :href="item.route ?? ''"
    target="_blank"
    :active="active"
    :active-color="activeColor"
    :text-color="textColor"
    :aria-label="ariaLabel"
    hover-opacity="0.10"
  >
    <VaSidebarItemContent :class="contentClass" :style="`padding-left: ${level}rem`">
      <VaIcon v-if="item.icon" aria-hidden="true" :name="item.icon" :size="externalIconSize" :color="iconColor" />
      <VaSidebarItemTitle :class="titleClass">
        {{ item.displayName ?? t(item.displayNameKey as string) }}
      </VaSidebarItemTitle>
      <VaIcon
        v-if="showExternalIcon"
        aria-hidden="true"
        name="open_in_new"
        size="16px"
        :color="favoriteColor"
        class="mr-1"
      />
      <a v-if="handleFavorite" @click.prevent.stop="handleFavorite(item)">
        <VaIcon
          v-if="item.route"
          aria-hidden="true"
          name="favorite"
          size="20px"
          :class="{ 'material-symbols-outlined': !item.isFavorite }"
          :color="favoriteColor"
        />
      </a>
    </VaSidebarItemContent>
  </VaSidebarItem>

  <VaSidebarItem
    v-else
    :to="{ name: item.route, params: routeParams }"
    :active="active"
    :active-color="activeColor"
    :text-color="textColor"
    :aria-label="ariaLabel"
    hover-opacity="0.10"
  >
    <VaSidebarItemContent :class="contentClass" :style="`padding-left: ${level}rem`">
      <VaIcon v-if="item.icon" aria-hidden="true" :name="item.icon" :size="iconSize" :color="iconColor" />
      <VaSidebarItemTitle :class="titleClass">
        {{ item.displayName ?? t(item.displayNameKey as string) }}
      </VaSidebarItemTitle>
      <a v-if="handleFavorite" @click.prevent.stop="handleFavorite(item)">
        <VaIcon
          v-if="item.route"
          aria-hidden="true"
          name="favorite"
          size="20px"
          :class="{ 'material-symbols-outlined': !item.isFavorite }"
          :color="favoriteColor"
        />
      </a>
    </VaSidebarItemContent>
  </VaSidebarItem>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { MenuHierarchy } from "@/pages/admin/menuHierarchy/types"
import { isExternalRoute } from "@shared/helpers/utils"

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    item: MenuHierarchy
    level: number
    iconColor: string
    textColor?: string
    active?: boolean
    activeColor?: string
    favoriteColor?: string
    ariaLabel?: string
    titleClass?: string
    contentClass?: string
    iconSize?: string
    externalIconSize?: string
    showExternalIcon?: boolean
    handleFavorite?: (item: MenuHierarchy) => void
  }>(),
  {
    textColor: undefined,
    active: false,
    activeColor: undefined,
    favoriteColor: "secondary",
    ariaLabel: undefined,
    titleClass: "leading-4 font-semibold text-wrap",
    contentClass: "py-1 pr-2",
    iconSize: "20px",
    externalIconSize: "20px",
    showExternalIcon: true,
    handleFavorite: undefined,
  },
)

const isExternal = computed(() => isExternalRoute(props.item.route ?? ""))

const routeParams = computed(() => {
  if (!props.item.routeParam) {
    return {}
  }

  try {
    return JSON.parse(props.item.routeParam)
  } catch {
    return {}
  }
})
</script>
